import { useEffect, useState } from 'react'
import validator from 'validator'
import { AuthService } from 'src/services/auth.service'
import { EAuthMethod } from 'src/types/login-method'

export const LOGIN_METHOD_DEBOUNCE_MS = 400

/**
 * Asks the backend how the user typed e-mail is supposed to log in, once it looks valid and the user
 * stopped typing. Anything but a confirmed OIDC answer keeps the password form.
 */
export const useLoginMethod = (rawEmail: string | undefined): EAuthMethod => {
  const [resolved, setResolved] = useState<{ email: string; method: EAuthMethod }>()
  const email = rawEmail?.trim().toLowerCase()

  useEffect(() => {
    if (!email || !validator.isEmail(email)) {
      return
    }

    let isStale = false
    const timeout = setTimeout(() => {
      AuthService.getLoginMethod(email).then((method) => {
        if (!isStale) {
          setResolved({ email, method })
        }
      })
    }, LOGIN_METHOD_DEBOUNCE_MS)

    return () => {
      isStale = true
      clearTimeout(timeout)
    }
  }, [email])

  // An answer only counts for the e-mail it was given for: editing the e-mail brings the password back.
  return resolved && resolved.email === email ? resolved.method : EAuthMethod.PASSWORD
}
